import { render, staticRenderFns } from "./deliveryDetail.vue?vue&type=template&id=4c61a288"
import script from "./deliveryDetail.vue?vue&type=script&lang=js"
export * from "./deliveryDetail.vue?vue&type=script&lang=js"
import style0 from "../assets/css/deliveryDetail.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports